<template>
    <div class="generalframezz">
        <div class="generalcontent" :style="{width:mywidth+'px',height:myheight+'px'}">
            <div :style="{height:myTitleheight+'px',lineHeight:myTitleheight+'px'}" class="general_title">
                <div class="general_title_left">
                    <div>充值</div>
                </div>
                <img @click="parentHandleclick()" class="timgclose" src="./images/ty_close.png" />
            </div>
            <div class="recharge-from">
                <div>充值金额：</div>
                <div><input v-model="money" class="text-input" type="text"  placeholder="充值金额应大于10元，仅支持整数，例如11元" @keyup="oneMoneyKeyup" /></div>
                <div>元（人民币）</div>
            </div>
            <p class="red-p" v-show="showMoney">{{moneyTip}}</p>           
            <div class="recharge-code" v-if="showCode==1">
                <div><img src="./images/wc.png" class="position-img" style="top:22px;left:35px;" /></div>
                <div><img src="./images/zfb.png" class="position-img" style="top:21px;left:212px;height:20px;" /></div>
                <Tabs type="card" active-key="key1" @on-click="changeTabs">
                    <Tab-pane label="微信支付" key="key1">                        
                        <img :src="wxCode" class="card-code" v-if="wxCode && wxCode"/>
                    </Tab-pane>
                    <Tab-pane label="支付宝支付" key="key2">
                        <img :src="zfbCode" class="card-code" v-if="zfbCode && zfbCode"/>
                    </Tab-pane>
                </Tabs>               
            </div> 
            <div class="recharge-code" v-else>
                <span>请输入充值金额生成二维码</span>
            </div>         
        </div>
    </div>
</template>

<script>
import { _getrecharge } from "@/api/wallet.js";
import _ from 'lodash';
    export default {
        name:'recharge',
        props:{
            mywidth:{
                type:String,
                default:'631'
            },
            myheight:{
                type:String,
                default:'495'
            },
            myTitleheight:{
                type:String,
                default:'50'
            },
            tishihide:{
                type:Boolean,
                default:true
            }
        },
        data(){
            return{
                money:"",
                moneyTip:"请输入提现金额",
                showMoney:false,
                wxCode:"",
                wxId:"",
                zfbCode:"",
                zfbId:"",
                showCode:0
            }
        },
        methods:{
            parentHandleclick() {
                clearInterval(this.clearTimer);
                //if(this.clearTimer) clearInterval(this.clearTimer);
                this.$emit('fatherModal');
                this.money="";
                this.moneyTip="";
                this.showMoney = false;
                this.showCode=0;
                this.wxCode="";
                this.wxId="";
                this.zfbCode="";
                this.zfbId="";
            },
            //生成二维码
            wxCodePay(){               
                const data={
                    increment:this.money,
                    //increment:0.01,
                    payWay:'wechatpay',
                }
                _getrecharge(data).then(res => {
                    if(res.code==200){
                        this.wxCode = res.result.qr;
                        this.wxId=res.result.id;
                        this.clearTimer = this.clearTimer || setInterval(this.getPayStatus, 2000);                        
                    }                                           
                });
            },
            zfbCodePay(){  
                const val={
                    increment:this.money,
                    //increment:0.01,
                    payWay:'alipay',
                }
                _getrecharge(val).then(res => {
                    if(res.code==200){
                        this.zfbCode = res.result.qr;
                        this.zfbId=res.result.id;
                        this.clearTimer = this.clearTimer || setInterval(this.getPayStatus, 2000);                       
                    }                                           
                });
            },
            //keyup事件
            oneMoneyKeyup:
              _.debounce(function() {
                if(Number(this.money)>=10){
                  this.wxCodePay();
                  this.zfbCodePay();
                  this.showCode=1
                } else{
                  this.showCode=0
                }
              }, 700),
            //选项卡选中
            changeTabs(val){

                clearInterval(this.clearTimer);
                this.clearTimer = undefined;

                if(val==0){
                    this.zfbCodePay();
                }else if(val==1){
                    this.zfbCodePay();
                }              
            },
            //查询支付状态
            getPayStatus(){
                this.getRequest("/registerVipMemberApplication/get/" + this.wxId).then(res => {
                    if(res.code==200){
                        if (res.result.payStatus == "paid") {
                            clearInterval(this.clearTimer);
                            toast("充值成功");
                            this.$emit('fatherModal');
                            this.$emit('findOne');
                            this.$emit('changeTabs',0);
                        }
                    }
                });
                this.getRequest("/registerVipMemberApplication/get/" + this.zfbId).then(res => {
                    if(res.code==200){
                        if (res.result.payStatus == "paid") {
                            clearInterval(this.clearTimer);
                            toast("充值成功");
                            this.$emit('fatherModal');
                            this.$emit('findOne');
                            this.$emit('changeTabs',0);
                        }
                    }
                });
            }         
        },
        watch:{
            'money':{
                handler:function(){
                    let re = /^[0-9]*$/;
                    if (re.test(Number(this.money))){
                        if (Number(this.money) < 10) {
                            this.moneyTip="充值金额不得低于10元"
                            this.showMoney = true;
                        } else {
                            this.moneyTip="";
                            this.showMoney = false;
                        }
                    }else{
                        this.moneyTip="请输入正整数金额"
                        this.showMoney = true;
                    }
                }
            },
        },
        beforeDestroy() {
            clearInterval(this.clearTimer);     
        }
    }
</script>

<style scoped lang="less">
    .generalframezz{
        background: rgba(0, 0, 0, 0.7);
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        text-align: center;
        margin: auto;
        z-index: 558;
        .generalcontent{
            background:#fff;
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            margin: auto;
            border-radius:8px;
            .general_title{
                background:rgba(255,255,255,1);
                box-shadow:0px 2px 18px 0px rgba(211,214,225,0.15);
                border-radius:8px 8px 0px 0px;
                font-size:14px;
                font-weight:400;
                color:rgba(51,51,51,1);
                display:flex;
                justify-content: space-between;
                padding:0 30px 0 20px;
                align-items: center;
                .general_title_left{
                    display:flex;
                    justify-content: flex-start;
                    align-items: center;
                }
                .timgtishi{
                    width:25px;
                    height:25px;
                    margin-right:10px;
                }
                .timgclose{
                    width:18px;
                    height:18px;
                    cursor: pointer;
                }
            }
            .recharge-from{
                height: 46px;
                margin:20px 50px 0px;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                font-size:14px;
                font-weight:400;
                color:rgba(51,51,51,1);
                .text-input{
                    width:332px;
                    height:46px;
                    border:0px;
                    outline: none;
                    border-radius:4px;
                    border:1px solid rgba(222,226,230,1);
                    text-indent: 10px;
                    margin:0px 20px 0px 25px;
                }
            }
            .recharge-code{
                height: 268px;
                margin:44px 131px 0px;
                position: relative;
                /deep/ .ivu-tabs-bar{
                    border-bottom:0px;
                    margin-bottom:0px;
                    position: relative;
                }
                /deep/ .ivu-tabs.ivu-tabs-card>.ivu-tabs-bar .ivu-tabs-nav-container{
                    height: auto;
                }
                /deep/ .ivu-tabs.ivu-tabs-card>.ivu-tabs-bar .ivu-tabs-tab{
                    width:169px;
                    height:62px;
                    line-height: 62px;
                    text-indent:30px;
                    background:rgba(255,255,255,1);
                    border-radius:4px;
                    border:1px solid rgba(233,233,233,1);
                    padding: 0px;
                    margin-right: 15px;
                    font-size:16px;
                    color:rgba(102,102,102,1);
                }
                /deep/ .ivu-tabs-nav-container:focus .ivu-tabs-tab-focused,
                /deep/ .ivu-tabs.ivu-tabs-card>.ivu-tabs-bar .ivu-tabs-tab-active{
                    box-shadow:0px 2px 40px 0px rgba(29,31,108,0.04)!important;
                    border:1px solid #121210!important;
                }
                .position-img{
                    position: absolute;
                    width:20px;
                    height: 18px;
                    z-index: 9999;                       
                }
                .card-code{
                    width:164px;
                    height: 164px;
                    margin-top:40px;
                }
                
            }
           
            // .recharge-code{
            //     height: 268px;
            //     margin:44px 131px 0px;
            //     ul{
            //         overflow: hidden;
            //         li{
            //             width:134px;
            //             float: left;
            //             text-align: left;
            //             list-style: none;
            //             .recharge-code-top{
            //                 font-size:16px;
            //                 font-weight:400;
            //                 color:rgba(51,51,51,1);
            //                 line-height:22px;
            //                 margin-bottom:20px;
            //                 img{
            //                     width:20px;
            //                     height: 20px;
            //                     vertical-align: middle;
            //                     margin-right:15px;
            //                 }
            //             }
            //             .recharge-code-bottom{
            //                 width:134px;
            //                 height:134px;
            //                 margin-bottom:25px;
            //             }
            //             p{
            //                 font-size:14px;
            //                 font-weight:400;
            //                 color:rgba(153,153,153,1);
            //                 line-height:20px;                            
            //             }
            //         }
            //     }
            // }
            // .btn-150{
            //     width:150px;
            //     height:37px;
            //     line-height: 37px;
            //     outline: none;
            //     border:0px;
            //     background:rgba(255,216,0,1);
            //     border-radius:21px;
            //     font-size:14px;
            //     font-weight:600;
            //     color:rgba(78,78,78,1);
            //     cursor: pointer;
            // }
        }
    }
    .red-p{
        color: #f00;
        text-align: left;
        margin-left: 145px;
    }
</style>